export const environment = {
    apiBaseUrls : {
      awsApiGateway: 'https://insights-uat.wsldev.com'
    },
    apiUrl: "https://insights-uat.wsldev.com",
    production: true
  };
  